import script from "./ClaimBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimBar.vue?vue&type=script&setup=true&lang=js"

import "./ClaimBar.vue?vue&type=style&index=0&id=5a70bcd1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a70bcd1"]])

export default __exports__